import { WbsSectionEntity } from '@/common/types/entities';
import { useApolloClient } from '@/plugins/apollo/apollo';

import { sectionsQuery } from '../sectionGql';

export async function queryProjectSections(
  projectId: string,
): Promise<Map<string, WbsSectionEntity>> {
  const client = useApolloClient();

  const result = await client.query({
    query: sectionsQuery,
    variables: {
      project: projectId,
    },
    fetchPolicy: 'no-cache',
  });

  return new Map(
    result.data.wbsSections?.map((v) => [
      v.id,
      {
        id: v.id,
        name: v.name,
        position: v.position,
        parentId: v.parent?.id ?? null,
      },
    ]) || [],
  );
}
